import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fieldProps", "proFieldProps"];
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ProField from '../Field';
/**
 * 文本选择组件
 *
 * @param
 */

var ProFormTextArea = function ProFormTextArea(_ref, ref) {
  var fieldProps = _ref.fieldProps,
      proFieldProps = _ref.proFieldProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(ProField, _objectSpread({
    ref: ref,
    valueType: "textarea",
    fieldProps: fieldProps,
    proFieldProps: proFieldProps
  }, rest));
};

export default /*#__PURE__*/React.forwardRef(ProFormTextArea);